import axiosInstance from "../axiosInstance";
import type {
  DuplicateLearningPathRequest,
  DuplicateLearningPathResponse,
} from "./types";

/**
 * Duplicate a learning path (deep copy → new draft).
 * POST /api/learning-paths/{pathId}/duplicate
 *
 * Voter: source VIEW + same-company learning admin (or super admin).
 * Errors propagate to the caller (axios error with the API body intact):
 * 403 not a learning admin for the source's company, 404 unknown path,
 * 422 invalid explicit name.
 */
export const duplicateLearningPath = async (
  pathId: number,
  request: DuplicateLearningPathRequest = {},
): Promise<DuplicateLearningPathResponse> => {
  const response = await axiosInstance.post<DuplicateLearningPathResponse>(
    `/api/learning-paths/${pathId}/duplicate`,
    request,
  );
  return response.data;
};
